import ComparisonModulesRenderer from '@/components/_rebrand/craft/ComparisonModulesRenderer';
import { LearnPathsQuery, LearnQuery, LearnQueryVariables } from '@/graphql';
import LearnQueryDocument from '@/graphql/queries/Learn.gql';
import LearnPathsQueryDocument from '@/graphql/queries/LearnPaths.gql';
import { getPageProps } from '@/lib/craft-page';
import CraftClient from '@/lib/graphql';
import { getStaticPagePaths, getStaticPageProps } from '@/lib/next';
import MasterTemplate from '@/templates/MasterTemplate';

const Learn: PageTemplate<LearnQuery> = (props) => {
  const entry = 'entry' in props ? props.entry : null;
  const isRebrandModularEntry = entry?.__typename === 'learn_rebrandModular_Entry';

  if (entry && isRebrandModularEntry) {
    return <ComparisonModulesRenderer modules={entry.comparisonModules} />;
  }

  return null;
};

Learn.template = (props) => {
  const entry = 'entry' in props ? (props as LearnQuery).entry : null;
  const isRebrandModularEntry = entry?.__typename === 'learn_rebrandModular_Entry';

  return <MasterTemplate {...props} className={isRebrandModularEntry ? 'mt-0' : ''} />;
};

export default Learn;

export const getStaticPaths = getStaticPagePaths('learn', async (context) => {
  const client = new CraftClient();

  const data = await client.request<LearnPathsQuery>(LearnPathsQueryDocument);

  const paths =
    data.entries?.map((path) => ({
      params: {
        slug: path?.slug!,
      },
    })) || [];

  return {
    paths,
    fallback: 'blocking',
  };
});

export const getStaticProps = getStaticPageProps<{}, { slug: string }>(
  (params) => `learn/${params?.slug}`,
  async ({ client, context: { params } }) => {
    const pageProps = await getPageProps<LearnQuery, LearnQueryVariables>({
      pathPrefix: '/learn',
      queryDocument: LearnQueryDocument,
      client,
      variables: {
        slug: params?.slug,
      },
    });

    if (!pageProps?.entry) {
      return { notFound: true };
    }

    return {
      props: {
        ...pageProps,
      },
    };
  },
);
